var _style, _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 -10 125 140",
    style: {
      enableBackground: "new 0 0 124 124"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.4;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:3;}\n\t.st2{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 62,
    cy: 62,
    r: 61.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 62,
    cy: 62,
    r: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.1,60L54.3,42.6c-1.6-1.1-3.8,0.1-3.8,2.1v34.6c0,1.9,2.1,3.1,3.8,2.1l26.8-17.3c1.1-0.7,1.5-2.3,0.7-3.4 C81.7,60.4,81.4,60.2,81.1,60L81.1,60z"
  })));
}

export default SvgPlayButton;